import Vue from 'vue'
import InputField from '@com/fields/InputField'
import { i18n } from '@js/i18n'

const template = `
<form novalidate>
  <md-dialog class="app__dialog"
            :md-active="opened" 
            :md-close-on-esc="false"
            :md-click-outside-to-close="false">

     <md-dialog-title>
     <p>{{ i18n.mod_save_seed() }}</p>
     <p>{{ i18n.mod_save_seed_subtitle() }}</p>
     </md-dialog-title>
     
     <div class="app__dialog-inner">     
       <input-field id="signup-recovery-seed"
                    type="password"
                    name="recovery-seed"
                   :label="i18n.lbl_seed()"
                   :readonly="true"
                   :togglePassword="true"
                   :value="form.seed"
       />
       
       <p>{{ i18n.mod_validate_seed_how() }}</p>
       
       <input-field id="signup-provide-seed"
                    type="password"
                    name="recovery-seed"
                   :label="i18n.lbl_validate_seed()"
                   :togglePassword="true"
                   :errorMessage="isSeedValid ? '' : i18n.lbl_seed_dont_match()"
                  v-model.trim="form.provideSeed" 
       />
     </div>
       
     <md-dialog-actions>
       <md-button class="md-primary" @click="submit">{{i18n.lbl_confirm() }}</md-button>
     </md-dialog-actions>
   </md-dialog>
 </form>
`

export function showRememberSeedMessage (seed) {
  const seedModal = document.createElement('div')
  document.querySelector('#app').appendChild(seedModal)

  return new Promise((resolve) => {
    const messageEl = new Vue({
      template,
      components: { InputField },
      data () {
        return {
          form: {
            provideSeed: '',
            seed
          },
          opened: true,
          i18n
        }
      },

      computed: {
        isSeedValid () {
          return this.form.seed === this.form.provideSeed
        }
      },

      methods: {
        close () {
          if (!this.isSeedValid) return
          this.opened = false
          this.$el.parentNode.removeChild(this.$el)
        },
        async submit () {
          if (!this.isSeedValid) return
          this.close()
          return resolve(true)
        }
      }
    })
    messageEl.$mount(seedModal)
  })
}



// WEBPACK FOOTER //
// ./src/js/modals/remember_seed.modal.js